import React, { useEffect, useRef, useState } from "react";
import HeaderInner from "../../Components/HeaderInner";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Carosle from "../../Components/Carosle";
import { useQuery } from "react-query";
import { InStayShopCategoriesAPI } from "../../API/InStayShopAPI";
import { Zoom } from "react-reveal";
import PharmacySubMenuLoader from "../../Components/Loaders/PharmacySubMenuLoader";
import { getImageUrl } from "../../utils/media";

function InStayShopSubMenu() {
  const location = useLocation();
  const rawPath = location.pathname;
  const room_uuid = rawPath.split("/")[1];
  const lang = sessionStorage.getItem("lang");
  const navigate = useNavigate();

  const { data, isLoading } = useQuery(`InStayShopCategories-${lang}`, () =>
    InStayShopCategoriesAPI({ room_uuid, lang }),
  );

  let title;
  let headerImages;
  let categories;

  if (!isLoading) {
    if (data?.data?.status === false) {
      navigate(`/${room_uuid}/qr-scan`);
    } else {
      title = data?.data?.data?.title.replace("In Stay", "In-Stay");
      headerImages = data?.data?.data?.banners;
      categories = data?.data?.data?.categories;

      if (categories?.length === 1) {
        navigate(`/${room_uuid}/in-stay-shop/items/${categories[0].id}`, {
          replace: true,
        });
      }
    }
  }

  // console.log("categories", categories);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0 });
  }, []);

  return (
    <>
      <HeaderInner headerName={title} />
      <main className="bg-white pad-top-0 resturant_category">
        {isLoading ? (
          <PharmacySubMenuLoader />
        ) : (
          <>
            {headerImages?.length > 0 && (
              <header className="img-header m-0">
                <Carosle headerImages={headerImages} />
              </header>
            )}

            <ul className="display-list two-items restaurant-list mt-2 v2">
              {categories?.map((category, idx) => (
                <Zoom key={idx}>
                  <li className="restaurant-option">
                    <Link
                      to={`/${room_uuid}/in-stay-shop/items/${category.id}`}
                      style={{ height: "140px" }}
                    >
                      <div className="closed-tag" />
                      <div />
                      <div className="img-pnl">
                        <img src={getImageUrl(category.image)} alt="" />
                      </div>
                      <div className="bg-layer" />
                      <p>{category.name}</p>
                    </Link>
                  </li>
                </Zoom>
              ))}
            </ul>
          </>
        )}
      </main>
    </>
  );
}

export default InStayShopSubMenu;
